// Browser-only PDF.js adapter, lazy-loaded when the author chooses Read as a Book.
// The caller passes the already SHA-verified approved PDF's blob URL.
// Never calls NextScenes APIs or alters publication artifacts.
export async function loadNovelApprovedPdfV1(blobUrl) {
  if (typeof blobUrl !== "string" || !blobUrl.startsWith("blob:")) {
    throw new Error("Exact approved PDF blob URL required.");
  }
  const pdfjs = await import("pdfjs-dist/webpack.mjs");
  return pdfjs.getDocument({ url: blobUrl, isEvalSupported: false });
}
